import api from './api';

export const chatService = {
  // Get or create chat for a bin
  getOrCreate: (binId) => api.get(`/chat/bin/${binId}`),

  // Get user's chats
  getUserChats: () => api.get('/chat/user'),

  // Send message
  sendMessage: (chatId, data) => api.post(`/chat/${chatId}/message`, data),

  // Mark messages as read
  markAsRead: (chatId) => api.put(`/chat/${chatId}/read`),
};
